// vim: set ts=2 sts=2 sw=2 et:
//
// This file is part of OpenLifter, simple Powerlifting meet software.
// Copyright (C) 2019 The OpenPowerlifting Project.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.

// The RootContainer manually implements route parsing from GET parameters.
//
// The issue is that because OpenLifter is statically hosted, only the base
// "/" route actually contains the index.html of the application. The other
// routes (such as "/lifting") have index.html files that redirect to "/".
//
// We've changed things so that "/lifting/index.html" redirects to "/?lifting".
// But React Router isn't able to route based on GET parameters.
//
// Therefore it's set up so that "/" routes to this RootContainer,
// and the RootContainer inspects the GET parameters and renders the
// appropriate container.

import React from "react";

import FlightDetailsContainer from "./FlightDetailsContainer";
import AudienceContainer from "./AudienceContainer";
import LeadersContainer from "./LeadersContainer";
import ResultsContainer from "./ResultsContainer";
import ObsLeadersViewBare from "../components/leaders/ObsLeadersViewBare";
import ObsFlightDetailsBare from "../components/flight-details/ObsFlightDetailsBare";
import ObsSessionDetailsBare from "../components/flight-details/ObsSessionDetailsBare";

class RootContainer extends React.Component {
  render() {
    if (typeof window.location.search !== "string") {
      return <ObsLeadersViewBare />;
    }

    switch (window.location.search) {
      case "?live":
        return <ObsLeadersViewBare />;
      case "?flight":
        return <ObsFlightDetailsBare />;
      case "?session":
        return <ObsSessionDetailsBare />;
      case "?results":
        return <ResultsContainer />;
      default:
        return <ObsLeadersViewBare />;
    }
  }
}

export default RootContainer;